import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/sales/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/sales/FeaturesList";
import Benefits from "../components/sales/Benefits";
import Cta from "../components/sales/Cta";
import Testimonials from "../components/sales/Testimonials";

const Sales = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Benefits />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Sales;
